module.exports = __webpack_public_path__ + "static/media/pizzaBocadillo.00b5e125.jpeg";